import { MatchStatus } from "service";

export const getNormalizedStatusCode = (status: MatchStatus) => {
  const raw = status.sc;
  if (typeof raw !== "string") return undefined;
  if (raw.length <= 4) return raw;
  return raw.slice(-4);
};
